import React from 'react';
import ShareButtonGroup, {
  ShareButtonGroupProps,
} from '../Social/ShareButtonGroup';
import Hidden, { HiddenProps } from '@material-ui/core/Hidden';

interface SnsButtonGroupProps extends ShareButtonGroupProps {
  hiddenProps: HiddenProps;
}

const SnsButtonGroup = ({
  hiddenProps,
  ...shareButtonGroupProps
}: SnsButtonGroupProps) => (
  <Hidden {...hiddenProps}>
    <ShareButtonGroup {...shareButtonGroupProps} />
  </Hidden>
);

export default SnsButtonGroup;
